import { defineStore } from 'pinia'

export const useHealthcheckStore = defineStore('healthcheck', {
  state: (): { hasError: boolean } => ({
    hasError: false,
  }),
})
